import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { NgForm } from '@angular/forms';
import { CommonService } from '../../Services/common.service';
import { ConfigSettingService } from '../../Services/config-setting.service';
import { DataManipService } from '../../Services/data-manip.service';
@Component({
  selector: 'app-log-of-wallet',
  templateUrl: './log-of-wallet.component.html',
  styleUrls: ['./log-of-wallet.component.css']
})
export class LogOfWalletComponent implements OnInit {
  showLoader: boolean = false;
  tableconfig={};
  tableheaders=[];
  tabledata=[];
  showGtPlusTbl=false;
  userid=0;
  showwalletGtPlusTbl=false;
  showTestGtPlusTbl=false;
  constructor(private router: Router, private datePipe:DatePipe, public dataManipSrvc: DataManipService, private commonServices: CommonService, private configSetting: ConfigSettingService) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.dataManipSrvc.headerName = "Users Topup Details";
    }, 80);
    this.getdetails();
  }


  getdetails(){
    this.showTestGtPlusTbl=false;
    this.tableheaders = [];
    this.tableconfig = [];
    this.tabledata =[];
  // console.log(this.userid)
      let apiUrl = this.configSetting.getBaseUrl() + "user/getUserWalletTransactionDetails";
   

      let body = {
        "userid": +this.userid,
      }
  
      this.commonServices.getWithParams(apiUrl, body).subscribe(successResp => {
     // this.showLoader = false;
      if (successResp['errorCode'] == "000000") {  
        this.showTestGtPlusTbl=true;  
        this.tableheaders = successResp["Data"]["tableheaders"];
        this.tableconfig = successResp["Data"]["tableconfig"];
        this.tabledata = successResp["Data"]["tabledata"];
        this.tableconfig['actioncolmconfig']['print']=false;
        this.tableconfig['actioncolmconfig']['view']=false;
        this.tableconfig['actioncolmconfig']['edit']=false;
        this.tableconfig['dragdrop']['columns'] = false;
      }
    })
    
  }
}
